import { organizationClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

/**
 * Better Auth browser client (plan Phase 7).
 * baseURL is empty → same origin (Vite proxy in dev, same-origin in prod).
 * organization plugin exposes useActiveOrganization, useListOrganizations, etc.
 */
export const authClient = createAuthClient({
  baseURL: '',
  plugins: [organizationClient()],
});

export type Session = typeof authClient.$Infer.Session;
